export default __webpack_public_path__ + "static/media/Newsletter.8928b09e.svg";